// store/usePlanExpiredPopupStore.js
import { create } from "zustand";

const usePlanExpiredPopupStore = create((set) => ({
  showPopup: false,
  isFreePlan: true,
  extensionRequested: false,   // ← new
  canExtend: true,             // ← new

  setPlanExpiredPopup: ({ showPopup, isFreePlan, extensionRequested = false, canExtend = true }) =>
    set({ showPopup, isFreePlan, extensionRequested, canExtend }),

  clearPlanExpiredPopup: () =>
    set({ showPopup: false, isFreePlan: true, extensionRequested: false, canExtend: true }),
}));

export default usePlanExpiredPopupStore;